import { api } from './client'

/** Uno Mobile - "Porta un amico". L'id cliente coincide con l'id contatto. */
export const UNO_MOBILE_OPERATOR_IDS = [5, 17]
export const UNO_MOBILE_MAX_CODES = 3

export interface UnoMobileReferrer {
  customerId: number
  name: string
  codesGenerated: number
  codesAvailable: number
}

export interface UnoMobileCode {
  id: number
  code: string
  used: boolean
  expiresOn?: string | null
  available: boolean
  friendContractId?: number | null
  friendCustomerId?: number | null
  generatedAt?: string | null
  source?: string | null
}

export interface UnoMobileAssignRequest {
  friendContractId: number
  friendCustomerId?: number
  referrerCustomerId?: number
}

export interface UnoMobileAssignResult {
  codeId: number
  code: string
  referrerCustomerId: number
  referrerName: string
  auto: boolean
  existing: boolean
  generated?: boolean
}

export const unoMobileApi = {
  referrers: (search = '', take = 20) => {
    const qs = new URLSearchParams()
    if (search.trim()) qs.set('search', search.trim())
    qs.set('take', String(take))
    return api<UnoMobileReferrer[]>(`/api/unomobile/referrers?${qs.toString()}`)
  },
  accountExists: (customerId: number) =>
    api<{ exists: boolean }>(`/api/customers/${customerId}/unomobile/account`),
  /** Le credenziali non si rileggono mai: si possono solo sostituire. */
  saveAccount: (customerId: number, login: string, password: string) =>
    api<{ exists: boolean; created: boolean }>(`/api/customers/${customerId}/unomobile/account`, {
      method: 'PUT', body: JSON.stringify({ login, password }),
    }),
  codes: (customerId: number) => api<UnoMobileCode[]>(`/api/customers/${customerId}/unomobile/codes`),
  assign: (data: UnoMobileAssignRequest) =>
    api<UnoMobileAssignResult>('/api/unomobile/assign', { method: 'POST', body: JSON.stringify(data) }),

  /** Attivazione guidata sul portale 1Mobile: sessione aperta sul server per la pratica. */
  activationStatus: (contractId: number) =>
    api<{ open: boolean }>(`/api/contracts/${contractId}/unomobile/activation`),
  activationStart: (contractId: number) =>
    api<{ open: boolean }>(`/api/contracts/${contractId}/unomobile/activation/start`, { method: 'POST' }),
  activationCmd: <T>(contractId: number, cmd: string, body: Record<string, unknown> = {}) =>
    api<T & { ok: true }>(`/api/contracts/${contractId}/unomobile/activation/${cmd}`, {
      method: 'POST', body: JSON.stringify(body),
    }),
  activationClose: (contractId: number) =>
    api<void>(`/api/contracts/${contractId}/unomobile/activation`, { method: 'DELETE' }),
}
